import * as React from 'react';
import { Query } from 'react-apollo';

import CAN_MAKE_PHONE_CALLS_QUERY from 'phoneCalls/queries/CanMakePhoneCallsQuery.gql';
import { CanMakePhoneCalls as CanMakePhoneCallsQueryResponse } from 'phoneCalls/queries/__generated__/CanMakePhoneCalls';

type Props = {
  children: (
    props: {
      canMakePhoneCalls?: boolean;
      loading: boolean;
      error: any;
    }
  ) => React.ReactElement;
};

/* Render component based on whether the user can make phone calls
 *
 * <CanMakePhoneCallsContainer>
 *   {({ canMakePhoneCalls }) => 
 *     {
 *       if (canMakePhoneCalls) {
 *         return <PhoneCallComponent />
 *       }
 *       return <NotPhoneCallComponent />
 *     }
 *   }
 * </CanMakePhoneCallsContainer>
 *
 */

export default function CanMakePhoneCallsContainer(props: Props): React.ReactElement {
  return (
    <Query<CanMakePhoneCallsQueryResponse, {}> query={CAN_MAKE_PHONE_CALLS_QUERY}>
      {({ loading, error, data }) => {
        const canMakePhoneCalls =
          data && data.me ? data.me.permissions.canMakePhoneCalls : undefined;
        return props.children({
          loading,
          error,
          canMakePhoneCalls,
        });
      }}
    </Query>
  );
}
